import React, {useState} from 'react'

const SelectTodo = ({ selectedTodo, onButtonClick }) => {
    return (
      <div>
        <div className="select-todo">
          <div className="prompt-msg">
            <i className="fa-regular fa-lightbulb"></i>やりたいことを選んでください
          </div>
          <div className="select-todo-container">
            <button className={`todo ${selectedTodo != "findCompany" && selectedTodo ? "unselected" : "selected"}`} onClick={() => onButtonClick('findCompany')}>企業を探す</button>
            <button className={`todo ${selectedTodo != "analyzeCompany" && selectedTodo ? "unselected" : "selected"}`} onClick={() => onButtonClick('analyzeCompany')}> 企業を分析する</button>
            <button className={`todo ${selectedTodo != "compareCompanies" && selectedTodo ? "unselected" : "selected"}`} onClick={() => onButtonClick('compareCompanies')}>企業を比較する</button>
            <button className={`todo ${selectedTodo != "analyzeIndustry" && selectedTodo ? "unselected" : "selected"}`} onClick={() => onButtonClick('analyzeIndustry')}>業界を分析する</button>
          </div>
        </div>
      </div>
  )
}

export default SelectTodo